import type { Collection, Pack } from "@prisma/client";

export const getPackFullName = (
  pack: Pick<Pack, "name">,
  collection: Pick<Collection, "name"> | null,
) => {
  return collection ? `${collection.name}: ${pack.name}` : pack.name;
};
